// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs__root--1LoSY Select__root--broZQ","select":"Tabs__select--2zUhm Select__root--broZQ","tab":"Tabs__tab--2sLtS","isActive":"Tabs__isActive--1lu1g"};